import { Index } from "components/SectorContactUs/Index";

export const SectorContactUs = () => {
  return <Index />;
};
